module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": {
        path: '/items',
        query: {
          mapel: _vm.item.id
        }
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.item.nama))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c67fb32a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/itembank/SubNavigation.vue
// module id = 1394
// module chunks = 0